import {Box} from 'src/design/atoms/Box';
import {Image} from 'src/design/atoms/Image';
import {Text} from 'src/design/atoms/Text';
import React from 'react';
import type {IFormFieldV2} from 'src/types/FormV2';
export interface FormViewSignatureV2Props {
  field: IFormFieldV2;
  value: string;
}

export const FormViewSignatureV2: React.FC<FormViewSignatureV2Props> = ({
  field,
  value,
}) => {
  return (
    <Box data-testid={`form-view-${field.name}`}>
      <Text fw={500} size="sm" c="dimmed" mb="xs">
        {field.label}
      </Text>
      {value && <Image maw={350} mah={150} src={value} alt="Signature" />}
    </Box>
  );
};
